function SwitchUserIcon({
  width = '16',
  height = '16',
  fillColor = '#F3E9D7',
}: {
  width?: string;
  height?: string;
  fillColor?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6667 6.00033C14.6667 6.00033 14.6667 8.66699 14.6667 8.66699V10.0003H10.6667V8.66699C10.6667 8.66699 10.6667 7.54033 9.90001 6.53366C9.78668 6.38033 9.64668 6.23366 9.50001 6.09366C9.84668 6.04033 10.2267 6.00033 10.6667 6.00033ZM1.33334 8.66699C1.33334 8.66699 1.33334 6.00033 5.33334 6.00033C9.33334 6.00033 9.33334 8.66699 9.33334 8.66699V10.0003H1.33334V8.66699ZM6.00001 11.3337V12.667H10V11.3337L12 13.3337L10 15.3337V14.0003H6.00001V15.3337L4.00001 13.3337L6.00001 11.3337ZM5.33334 0.666992C4.22668 0.666992 3.33334 1.56033 3.33334 2.66699C3.33334 3.77366 4.22668 4.66699 5.33334 4.66699C6.44001 4.66699 7.33334 3.77366 7.33334 2.66699C7.33334 1.56033 6.44001 0.666992 5.33334 0.666992ZM10.6667 0.666992C9.56001 0.666992 8.66668 1.56033 8.66668 2.66699C8.66668 3.77366 9.56001 4.66699 10.6667 4.66699C11.7733 4.66699 12.6667 3.77366 12.6667 2.66699C12.6667 1.56033 11.7733 0.666992 10.6667 0.666992Z"
        fill={fillColor}
      />
    </svg>
  );
}

export default SwitchUserIcon;
